function openTab(evt, tabName) {
  const contents = document.getElementsByClassName("collection-types_content-item");
  const links = document.getElementsByClassName("collection-types_tabs-button");

  for (let i = 0; i < contents.length; i++) {
    contents[i].classList.remove("fade-in");
  }

  for (let i = 0; i < links.length; i++) {
    links[i].classList.remove("active");
  }

  const activeTab = document.getElementById(tabName);
  activeTab.classList.add("fade-in");
  
  evt.currentTarget.classList.add("active");
}